var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6274 5.65025C11.6274 -0.469303 2.37427 -0.630342 2.37427 5.65025M2.37427 5.65025H3.01241V10.0789M2.37427 5.65025C1.88234 5.84965 0.919861 6.59356 1.00534 7.97407C1.09081 9.35459 2.379 9.95248 3.01241 10.0789M3.01241 10.0789C3.01241 12.1724 4.55259 13 6.44245 13V12.1724M11.6257 5.65024H10.9876V10.0789C11.621 9.95247 12.9092 9.35458 12.9947 7.97407C13.0801 6.59355 12.1177 5.84964 11.6257 5.65024Z",
    stroke: "#3F8CFF",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport1);
export default __webpack_public_path__ + "static/media/support1.066263246c178c50679c3ff079eb9f97.svg";
export { ForwardRef as ReactComponent };